var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-quick-tour',{attrs:{"height":_vm.videoHeight,"video-name":"explainer_IdeaPlan"}},[_c('h4',{staticClass:"my-3 my-xl-0 font-outfit-medium"},[_vm._v(" "+_vm._s(_vm.$t('welcomeToIdeaPlan'))+" ")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('ideaPlanQuickTourText'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }